import React, {useState} from 'react'
import { useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import { post } from '../../Services/Api';
import LeftArrow from './../../Assets/images/left-arrow.svg';
import Opennotification from '../../Components/Opennotification';
import { useLocation } from 'react-router-dom';
import { notification } from "antd";

const NewPassword = () => {
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [newpassword,setnewpassword] = useState("");
  const [confirmpassword,setconfirmpassword] = useState("");
  const [otptext,setotptext] = useState("");

  const navigate = useNavigate();

   const location = useLocation();
    const {email} = location.state || {};

  const handleNewPassword = (e)=>{
    e.preventDefault();
    setnewpassword(e.target.value)
  }

  const handleConfirmNewPassword = (e)=>{
    e.preventDefault();
    setconfirmpassword(e.target.value)
  }

  const handleotpText = (e)=>{
    e.preventDefault();
    setotptext(e.target.value);
  }

  const handleResetPassword = async(e)=>{
    e.preventDefault();
    if (!newpassword || !confirmpassword || !otptext) {
      Opennotification("warning", "Empty Fields", "Please don't leave fields empty.");
      return;
    }

    // Validate password length
    if (newpassword.length < 8) {
      notification.warning({
        message: "Validation Error",
        description: "Password must be at least 8 characters long.",
      });
      return;
    }
  
    if (newpassword !== confirmpassword) {
      Opennotification("error", "Password Mismatched", "Failed to reset password.");
      return;
    }
    try{

      const payload = {
        email: email,
        otp: otptext,
        new_password: newpassword,
        confirm_password: confirmpassword

      }

      console.log("payload::",payload);
      
      
      const response = await post(`verifyforgotpasswordotp`,payload)

      if(response && response.status === 200)
      {
        Opennotification("success","Password Updated")
        localStorage.removeItem("emailEntered");
        navigate("/")
        
        
      }
      else{
        console.log("error");
        
        console.error("Error response:", e.response); // Debugging line
        console.error("Error data:", e.response?.data); // Debugging line
        Opennotification(
          "error",
          "Failed To Update Password"
        );
        
      }
     
    }
    catch(e){
    if (e.response?.status === 400) {
      const errorMessage = e.response?.data?.msg || "An error occurred.";
      Opennotification("error", "Failed To Update Password", errorMessage);
    } else {
      // Handle other errors
      Opennotification(
        "error",
        "Error",
        "An error occurred while processing your request. Please try again."
      );
    }

    
    }
  }


  return (
    <div className="position-relative login-bg">
      {/* <div className="login-bg"></div> */}
      <div className="container vh-100">
        <div className="row align-items-center h-100">
          <div className="col-lg-6">
              <div className="bg-white login-main-box">
                  <h4 className="heading">SHARED PARKING</h4>

                  <h3 className="title mb-2">
                  Set new password
                  </h3>
                  {/* <p className="mb-5" style={{color: '#797979', fontSize: '16px'}}>
                  must be atleast 8 characters
                  </p> */}
                  <form>
                  <div className="form-group mb-4">
                    <label htmlFor="">Password</label>
                    <input 
                    type="password"
                    className="form-control"
                    value={newpassword}  
                    onChange={handleNewPassword}
                    />
                  </div>
                  <div className="form-group mb-5">
                    <label htmlFor="">Confirm Password</label>
                    <input 
                    type="password"
                    className="form-control" 
                    value={confirmpassword}
                    onChange={handleConfirmNewPassword}
                    />
                  </div>
                  <div className="form-group mb-5">
                    <label htmlFor="">Otp</label>
                    <input 
                    type="text"
                    className="form-control" 
                    value={otptext}
                    onChange={handleotpText}
                    />
                  </div>
                  <button 
                  className="btn btn-primary w-100 my-3"
                  onClick={handleResetPassword}
                  >
                    Reset Password
                  </button>
                  </form>
                  <p className="text-center sign-up-below">
                     <a href="/">
                       <img src={LeftArrow} alt="" className="me-2" style={{width: '15px'}} />
                       Back to Login </a> 
                  </p>
              </div>
          </div>
          <div className="col-lg-6">

          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPassword;